export default (list, sortBy) => {
  if (['lastPending', 'dim', 'created_at', 'database_entry_time'].includes(sortBy.key)) {
    list.sort((a, b) => {
      let x = a;
      let y = b;
      if (sortBy.direction) {
        x = b;
        y = a;
      }
      if (x[sortBy.key] < y[sortBy.key]) {
        return -1;
      }
      if (x[sortBy.key] > y[sortBy.key]) {
        return 1;
      }
      return 0;
    })
  } else if(['eartag'].includes(sortBy.key)){
    list.sort((a,b) => {
      let x = a;
      let y = b;
      if(sortBy.direction){
        x = b;
        y = a;
      }
      if(x.cow.eartag < y.cow.eartag){
        return -1;
      }
      if(x.cow.eartag > y.cow.eartag){
        return 1;
      }
      return 0;
    })
  }
  else {
    list.sort((a, b) =>
      sortBy.direction
        ? String(b[sortBy.key] === null ? "" : b[sortBy.key])
        .toLowerCase()
        .localeCompare(
          String(a[sortBy.key] === null ? "" : a[sortBy.key]).toLowerCase()
        )
        : 
          String(a[sortBy.key] === null ? "" : a[sortBy.key])
          .toLowerCase()
          .localeCompare(
            String(b[sortBy.key] === null ? "" : b[sortBy.key]).toLowerCase()
          )
    );
  }

  return list;
};



// WEBPACK FOOTER //
// ./src/helpers/SortList.js